import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { IPartyForUser } from '../../PartyClientResponse';
import { getAllParties } from '../../controller/PartyDB';
import PageContainer from '../layout/PageContainer';
import Logo from '../logo/Logo';
import { BuilderComponent } from '@builder.io/react';
import { APP_TITLE_BASE } from '../party/AppConstants';

// const IconText = ({ icon, text }: { icon: React.ElementType; text: string }) => {
//   const Icon = icon;
//   return (
//     <span>
//       <Icon style={{ marginRight: 8 }} />
//       {text}
//     </span>
//   );
// };

const LandingPage = () => {
  const [, setParties] = useState<IPartyForUser[]>([]);
  const history = useHistory();

  useEffect(() => {
    document.title = `${APP_TITLE_BASE} | Home`;
  }, []);

  useEffect(() => {
    (async () => {
      setParties(await getAllParties());
    })();
  }, []);

  if (process.env.NODE_ENV === 'production') {
    return <BuilderComponent model='page' url='/' />;
  }

  return (
    <PageContainer className='landing'>
      <div style={{ marginBottom: 100 }}>
        <Logo width='800' />
        {/* <span style={{ fontSize: 64 }}>Backroom Social Club</span> */}
      </div>
      <div
        style={{ position: 'absolute', right: 20, top: 20, cursor: 'pointer' }}
        onClick={() => history.push(`/${process.env.REACT_APP_DEFAULT_PARTY}`)}>
        <img alt='join party' src='/join_party_v2_g.svg'></img>
      </div>
      <div className='hero'>
        <iframe
          title='hero title'
          width='800'
          height='450'
          src='https://www.youtube.com/embed/1PUYTJwQrpo'
          frameBorder='0'
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
          allowFullScreen></iframe>
      </div>

      <div className='copy-that'>
        <br />
        <hr />
        <p>
          Backroom Social Club is the future of virtual (and hybrid) gatherings. We created Backroom
          Social Club so fans at home can interact with performers, and each other, like they would
          at the club. We are committed to supporting artists, collectives, and social causes.
        </p>
        Join us for the party!
      </div>

      <div className='copy-that'>
        <br />
        <hr />
        <p>
          <h1>Event Calendar</h1>
        </p>
        <a href='/puchteca'>
          <img src='/puchteca-ver.jpg' height='1200' alt='' />
        </a>
      </div>

      <div className='copy-that'>
        <br />
        <hr />
        <p>
          <h1>Party Demos</h1>
        </p>
        Wanna give it a try? Here are some existing parties to check out! Two things before you
        enter:
        <p>
          If you enter a party and the DJ isn't live, just come back and try another one
          <br />
          The dancefloor will likely be empty - this is just a space for you to give this a try
        </p>
        <h3>Existing Party Demos</h3>
        <p>
          <a href='/insomniac'>Insomniac</a>
        </p>
        <p>
          <a href='/gabrielanddresden '>Gabriel & Dresden</a>
        </p>
        <p>
          <a href='/clubrapture'>Rapture</a>
        </p>
        <p>
          <a href='/nyanjunafamily'>NY Anjunafamily</a>
        </p>
      </div>

      <div className='copy-that'>
        <br />
        <hr />
        <p>
          <h1>Host a Party</h1>
        </p>
        Reach out to us for more information!
        <br />
        <a href='mailto:iwannaparty@backroom.social'>iwannaparty@backroom.social</a>
      </div>

      <div className='copy-that'>
        <br />
        <hr />
        <p></p>
      </div>
      {/* <div>
        <Logo width='150' />
        <span style={{ fontSize: 64 }}>Backroom Social Club</span>
      </div>1
      <div>
        Take over the dance floor, chill at the bar, or get together with your friends in your
        private room. Come alone or with your house party.
        <br />
        <br />
        Join people from all over the world, reconnect with friends and make new ones. Whether you
        like music, dance, or just hanging out with your tribe, you can find your vibe in the back
        room.
        <br />
        <br />
        Backroom Social Club is the future of virtual gathering. We are committed to support
        artists, collectives and social causes. Join us for the ride.
      </div> */}
      <div id='mc_embed_signup'>
        <form
          action='https://social.us2.list-manage.com/subscribe/post?u=a11cf56425aa00b6186777fde&amp;id=aa5b309962'
          method='post'
          id='mc-embedded-subscribe-form'
          name='mc-embedded-subscribe-form'
          className='validate'
          target='_blank'
          noValidate>
          <div id='mc_embed_signup_scroll'>
            <label htmlFor='mce-EMAIL'>Sign up for the Beta now</label>
            <input
              style={{ marginRight: '1em' }}
              type='email'
              value=''
              name='EMAIL'
              className='email'
              id='mce-EMAIL'
              placeholder='email address'
              required></input>
            <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden='true'>
              <input
                type='text'
                name='b_a11cf56425aa00b6186777fde_aa5b309962'
                tabIndex={-1}
                value=''></input>
            </div>
            <div className='clear'>
              <input
                type='submit'
                value='Subscribe'
                name='subscribe'
                id='mc-embedded-subscribe'
                className='button'></input>
            </div>
          </div>
        </form>
      </div>
    </PageContainer>
  );
};

export default LandingPage;
